import Button from '@doordash/component-button'
import { Colors, Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'
import { TABLET_HEADER_WIDTH, GET_STARTED_BTN_Z_INDEX } from '../../constants'

type ExperimentQ3Props = {
  experimentQ3?: boolean
}

export const ButtonContainer = styled.div`
  display: none;
  ${(props: ExperimentQ3Props) =>
    props.experimentQ3
      ? `
    @media (max-width: ${TABLET_HEADER_WIDTH}px) {
      display: block;
      position: fixed;
      width: 100vw;
      padding: ${Spacing.Medium}px;
      bottom: 0;
      background: ${Colors.SystemWhite};
      border-top: 1px solid ${Colors.SystemGrey5};
      z-index: ${GET_STARTED_BTN_Z_INDEX};
    }
  `
      : `
    ${Media.Mobile`
    display: block;
    position: fixed;
    width: 100vw;
    padding: ${Spacing.Medium}px;
    bottom: 0;
    background: ${Colors.SystemWhite};
    border-top: 1px solid ${Colors.SystemGrey5};
    z-index: ${GET_STARTED_BTN_Z_INDEX};
  `}
  `}
`

export const GetStartedButton = styled(Button).attrs<{}>({
  type: Button.Types.PrimaryPill,
})``
